import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=3b5d92dd&scoped=true&"
import script from "./BaseTabs.vue?vue&type=script&lang=ts&"
export * from "./BaseTabs.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&id=3b5d92dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d92dd",
  null
  
)

export default component.exports